__turbopack_context__.v({
  "list": "mantineTabs-module-scss-module__E9egLG__list",
  "tab": "mantineTabs-module-scss-module__E9egLG__tab",
});
